import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {DenialLetterParams} from 'domain/usecases';
import {getDenialLetter} from '../services/getDenialLetter';

export const useGetDenialLetterQuery = (params: DenialLetterParams) =>
	useQuery({
		queryKey: [QUERY_KEYS.AUTOSOL_DENIAL_LETTER, params],
		queryFn: async ({signal}) => getDenialLetter({...params, signal}),
		enabled: false,
	});
